// @flow
import { ServiciosActionTypes } from './constants';

type ServiciosAction = { type: string, payload: {} | string };

// common success
export const serviciosApiResponseSuccess = (actionType: string, data: any): ServiciosAction => ({
    type: ServiciosActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const serviciosApiResponseError = (actionType: string, error: string): ServiciosAction => ({
    type: ServiciosActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getServicio = (id: string): ServiciosAction => ({
    type: ServiciosActionTypes.GET_SERVICIO,
    payload: { id },
});

export const addServicio = (servicio:any):ServiciosAction=>({
    type:ServiciosActionTypes.ADD_SERVICIO,
    payload:servicio
})
export const updateServicio = (servicio:any):ServiciosAction=>({
    type:ServiciosActionTypes.UPDATE_SERVICIO,
    payload:servicio
})
export const deleteServicio = (id:string):ServiciosAction=>({
    type:ServiciosActionTypes.DELETE_SERVICIO,
    payload:{id}
})

export const listServicios = (params:any): ServiciosAction => ({
    type: ServiciosActionTypes.LIST_SERVICIOS,
    payload: params,
});


export const resetServicios = (): ServiciosAction => ({
    type: ServiciosActionTypes.RESET,
    payload: {},
});

